import { Typography, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

const AmlddSearchTerms = ({ busca, showTitle = true }) => {
  const { t } = useTranslation(['common'])

  if (!busca || busca.length === 0) {
    return null
  }

  // Detectar si el primer elemento parece un nombre y el segundo un documento
  const formatSearchTerms = () => {
    if (busca.length === 0) return []

    // Si son objetos con nome/documento
    if (typeof busca[0] === 'object' && busca[0] !== null) {
      return busca.map((term, idx) => {
        const parts = []
        if (term.nome) parts.push(`Nome: ${term.nome}`)
        if (term.name) parts.push(`Nome: ${term.name}`)
        if (term.documento) parts.push(`Documento: ${term.documento}`)
        if (term.document) parts.push(`Documento: ${term.document}`)
        return { key: idx, parts }
      }).filter(item => item.parts.length > 0)
    }

    // Si son strings simples, intentar detectar si son nombre/documento
    const formatted = []
    busca.forEach((term, idx) => {
      const termStr = String(term).trim()
      // Si parece un documento (solo números o formato de CPF/CNPJ)
      if (/^\d+$/.test(termStr) || /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(termStr) || /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(termStr)) {
        formatted.push({ key: idx, label: 'Documento', value: termStr })
      } else {
        // Probablemente es un nombre
        formatted.push({ key: idx, label: 'Nome', value: termStr })
      }
    })
    return formatted
  }

  const formattedTerms = formatSearchTerms()

  return (
    <div style={{ gridColumn: '1 / 3' }}>
      {showTitle && (
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          {t('common:amldd.searchTerms')}
        </Typography>
      )}
      <Box sx={{ pl: showTitle ? 2 : 0 }}>
        {formattedTerms.map((item) => {
          if (item.parts) {
            // Objetos con partes
            return (
              <Box key={item.key} sx={{ mb: 1 }}>
                {item.parts.map((part, partIdx) => (
                  <Typography key={partIdx} variant="subtitle3" sx={{ display: 'block', mb: 0.5 }}>
                    • {part}
                  </Typography>
                ))}
              </Box>
            )
          } else {
            // Strings formateados
            return (
              <Typography key={item.key} variant="subtitle3" sx={{ display: 'block', mb: 0.5 }}>
                • {item.label}: {item.value}
              </Typography>
            )
          }
        })}
      </Box>
    </div>
  )
}

export default AmlddSearchTerms
